import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AnalysisProgress } from '@shared-interfaces/shared-workflow';

export interface ContentCollectionUpdateInput {
    active_step: number;
}

export interface ContentCollectionResponse {
    uid: string;
    active_step: number;
    status?: string;
    step?: number;
    specifications?: {
        progress?: AnalysisProgress;
        numberOfQuestions?: number;
        [key: string]: any;
    };
    runningProcesses?: Array<{ uid: string; status: string; name?: string }>;
    [key: string]: any;
}

@Injectable({
    providedIn: 'root'
})
export class ContentCollectionService {
    
    constructor(private http: HttpClient) {}

    /**
     * Fetch the full content collection document (lightweight — used for progress polling)
     */
    getContentCollection(contentCollectionId: string): Observable<ContentCollectionResponse> {
        const url = `api/v1/content-collection/subscription/${contentCollectionId}`;
        return this.http.get<ContentCollectionResponse>(url);
    }

    /**
     * Update the active step for a content collection
     * @param contentCollectionId The content collection ID
     * @param activeStep The active step value (7-digit DORA number)
     */
    updateActiveStep(contentCollectionId: string, activeStep: number): Observable<ContentCollectionResponse> {
        const url = `api/v1/content-collection/subscription/${contentCollectionId}`;
        return this.http.put<ContentCollectionResponse>(url, { active_step: activeStep });
    }

    /**
     * Update content collection with partial data
     * @param contentCollectionId The content collection ID
     * @param updateData The data to update
     */
    updateContentCollection(contentCollectionId: string, updateData: Partial<ContentCollectionResponse>): Observable<ContentCollectionResponse> {
        const url = `api/v1/content-collection/subscription/${contentCollectionId}`;
        return this.http.put<ContentCollectionResponse>(url, updateData);
    }
}
